import React, { useState } from 'react';
import StyledH6Heading from '../../../common/components/styledH6Heading/StyledH6Heading';
import StyledMdText from '../../../common/components/styledMdText/StyledMdText';
import StyledXsText from '../../../common/components/styledXsText/StyledXsText';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import { useMintingStateContext } from "../../../context/CrowdfundingContext";
import { useAccount } from 'wagmi';
import StyledXlText from '../../../common/components/styledXlText/StyledXlText';
import ProjectsCard from '../../../components/projectsCard/ProjectsCard';
import { useEffect } from 'react';
import { slicedAddress } from '../../../helpers/helpers';

const ProfileSection = () => {
  const { fetchAllProjects, getBalance } = useMintingStateContext();
  const [projects, setProjects] = useState([])
  const [totalBalance, setTotalBalance] = useState(null);
  const account = useAccount();

  const getAllProjects = async () => {
    try {
      const response = await fetchAllProjects();
      setProjects(response)
    }
    catch (error) {
      console.log("��� ~ getAllProjects ~ error:", error)
    }
  }

  const getTotalBalance = async () => {
    try {
      const response = await getBalance(account?.address);
      setTotalBalance(response)
    }
    catch (error) {
      console.log("��� ~ getTotalBalance ~ error:", error)
    }
  }

  useEffect(() => {
    getTotalBalance()
    getAllProjects();
  }, []);

  return (
    <div className='py-32 text-white w-[90%] flex flex-col items-center gap-10'>
      <div className='flex flex-col items-center gap-5'>
        <StyledH6Heading fontColor="text-gradient">My Profile</StyledH6Heading>
        <StyledMdText fontColor="text-white">Here are all of the details of your profile.</StyledMdText>
      </div>
      <div className='flex flex-col w-full gap-3'>
        <hr className='bg-white h-[0.5px] w-full' />
        <div className='flex justify-between w-full'>
          <div>
            <StyledXsText fontColor="text-white">Your Wallet Address : <span className='!text-gradient'>{slicedAddress(account.address)}</span></StyledXsText>
          </div>
          <div>
            <StyledXsText fontColor="text-white">Your Balance : <span className='!text-gradient'>{Number(totalBalance) / (10 ** 18)} HOPE</span></StyledXsText>
          </div>
        </div>
      </div>
      {projects.length === 0 ? (
        <div className='flex flex-col items-center gap-8 pt-10'>
          <div>
            <img width={500} height={300} src='/assets/images/nothingFound.webp' alt='Nothing' />
          </div>
          <div className='flex flex-col gap-3 text-center'>
            <div>
              <StyledXlText fontColor="text-gradient">Nothing found!</StyledXlText>
            </div>
            <StyledMdText fontColor="text-white">But Don't Worry, We are continuously validating the best projects for you.</StyledMdText>
          </div>
        </div>
      ) : (
        <div className='grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'>
          {
            projects.filter(item => item.createdBy === account.address).map((project, index) => (
              <div key={index}>
                <ProjectsCard project={project} donate={false} />
              </div>
            ))
          }
        </div>
      )}
    </div>
  );
};

export default ProfileSection;
